import { dateFormatServer } from '@alluradirect/react';
import styled from 'styled-components';
import Tooltip from '@mui/material/Tooltip';
import { SelectedDateRange } from 'components/views/pages/Checkout/CheckoutDateRangePicker/useDateRangePicker';
import { UnavailableDates } from 'components/views/pages/Checkout/hooks/usePropertyUnavilableDates';
import { Box } from '@mui/material';

interface Props {
  day: Date;
  modifiers: any;
  selectedDateRange: SelectedDateRange;
  minNights: UnavailableDates['MIN_NIGHTS_DATES'];
  ratesData?: { [date: string]: [rate: string] };
}

const RateDisplay = styled.div`
  font-size: 0.7rem;
  margin-top: -2px;
  line-height: 1;  
  font-weight: 400;
`;

export const DateRangePickerDay = ({ day, modifiers, selectedDateRange, minNights, ratesData }: Props) => {
  const dateStr = dateFormatServer(day);
  const rateDisplay = ratesData?.[dateStr] ?? "-";
  if (modifiers.minNight && selectedDateRange.from && minNights) {
    const strDay = dateFormatServer(selectedDateRange.from);

    const minNightDate = minNights.find(date => {
      const key = Object.keys(date)[0];
      return key === strDay;
    });

    const nights = `${Object.values(minNightDate as any)[0]}-`;
    return (
      <Tooltip title={`${nights}night minimum`} enterTouchDelay={0} arrow>
        <Box>
          <div>{day.getDate()}</div>
          <RateDisplay>{rateDisplay}</RateDisplay>
        </Box>
      </Tooltip>
    );
  }
  return <>
    <div>{day.getDate()}</div>
    <RateDisplay>{rateDisplay}</RateDisplay>
  </>;
};
